import { IS_PROD } from '../config/env'

const TESTING_KEY = [
    'ControlButton',
    'NavLink',
    'NavMobileBackdrop',
    'NavMobileMenuButton',
    'NavChat',
    'GateFeedSectionExpandButton',
    'GateFeedTag',
    'TagClear',
    'GateFeedSection',
    'GateFeedAddButton',
    'GateFeedDetailsRow',
    'GateFeedRow',
    'GateFeedDetailsRowMoreButton',
    'GateFeedDetailsRowCloseButton',
    'GateFeedDetailsRowSaveButton',
    'GateFeedDetailsRowEditButton',
    'GateFeedDetailsRowCancelButton',
    'GateFeedDetailsRowDeleteButton',
    'GateFeedTable',
    'GateFeedInputTextInput',
    'GateFeedEditItemButton',
    'GateFeedInputSelect',
    'GateFeedInputSwitch',
    'GateFeedDateInput',
    'GateFeedTimeInput',
    'GateFeedFilterLocationSelect',
    'GateFeedFilterGateSelect',
    'GateFeedFilterPropertySelect',
    'GateFeedFilterPropertySelectPicker',
    'GateFeedFilterDateSelect',
    'GateFeedFilterIsBareCheck',
    'GateFeedFilterTagsClearAllButton',
    'GateFeedFilterTag',
    'GateFeedFilterTagsClearButton',
    'GateFeedDownloadButton',
    'DownloadWindow',
    'AuthEmail',
    'AuthPassword',
    'AuthSubmit',
    'Error',
] as const

export type TestingKey = (typeof TESTING_KEY)[number]
export type TestingKeyParams = [TestingKey] | [TestingKey, string | undefined]
/**
 * Creates a data property to be used in E2E testing
 * @param selectorKey
 * @param optionalIdentifier
 */
export const insertTestingSelector = (...params: TestingKeyParams): { 'data-cy'?: string } => {
    if (IS_PROD) {
        return {}
    }
    const [testingKey, optionalModifier] = params

    const key: string[] = [testingKey]
    if (optionalModifier) key.push(optionalModifier)

    return {
        'data-cy': key.join('_'),
    }
}
